export default __webpack_public_path__ + "static/media/DeliveryReport.0785c93c.svg";